import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const root = css`
  display: grid;
  list-style: none;
  padding: 0;
  margin: 0;
`

export const variant = {
  small: css`
    row-gap: ${size[12]};
  `,
  medium: css`
    row-gap: ${size[16]};
  `,
}
